/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Low_ButtonInputs */



/**
* | output |
* | --- |
* | "Low" |
*
* @param {Scene_Change_Detection_Low_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_low_button = /** @type {((inputs?: Scene_Change_Detection_Low_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Low_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Faible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Niedrig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Низкий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("低的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("低い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixo")
	return /** @type {LocalizedString} */ ("Low")
});